import { Link } from "react-router-dom";

const industries = [
  { icon: "ri-bank-line", title: "Financial Services", desc: "Fraud detection, risk AI & customer assistants" },
  { icon: "ri-heart-pulse-line", title: "Healthcare", desc: "Clinical NLP, patient chatbots & admin automation" },
  { icon: "ri-government-line", title: "Government", desc: "Citizen services AI & compliance automation" },
  { icon: "ri-store-2-line", title: "Retail & Ecommerce", desc: "Personalization, visual search & inventory agents" },
  { icon: "ri-graduation-cap-line", title: "Education", desc: "AI tutors, content generation & learning analytics" },
  { icon: "ri-flashlight-line", title: "Energy & Infrastructure", desc: "Predictive maintenance & grid optimization" },
];

const whyItems = [
  { icon: "ri-global-line", title: "Global + Local", desc: "Chicago HQ, Lagos delivery, 24/7 coverage" },
  { icon: "ri-brain-line", title: "AI-First DNA", desc: "AI is our core, not an add-on" },
  { icon: "ri-shield-star-line", title: "Strategic Alliances", desc: "Microsoft, AWS & Google Cloud certified" },
  { icon: "ri-line-chart-line", title: "Business-Centric", desc: "Every solution ties to your KPIs" },
];

export default function IndustriesSection() {
  return (
    <section className="py-20 bg-slate-50" id="industries">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-building-4-line text-[#9bc400] text-xs" />
            <span className="text-slate-500 text-xs font-semibold uppercase tracking-wider">Industries We Serve</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-3">AI for Every Sector</h2>
          <p className="text-slate-500 text-base max-w-xl mx-auto">Deep domain expertise across the industries that matter most.</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-16">
          {industries.map((ind) => (
            <div key={ind.title} className="bg-white border border-slate-100 rounded-xl p-5 text-center hover:border-[#C8F135]/50 hover:-translate-y-0.5 transition-all cursor-default group">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#C8F135]/10 mx-auto mb-3 group-hover:bg-[#C8F135]/20 transition-colors">
                <i className={`${ind.icon} text-[#9bc400] text-lg`} />
              </div>
              <h3 className="text-xs font-bold text-slate-900 mb-1 leading-tight">{ind.title}</h3>
              <p className="text-xs text-slate-400 leading-tight hidden sm:block">{ind.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-black rounded-2xl p-8 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 items-start lg:items-center">
            <div className="lg:w-56 flex-shrink-0">
              <p className="text-[#C8F135] text-xs font-semibold uppercase tracking-wider mb-2">Why CPI Technologies</p>
              <h3 className="text-white font-black text-2xl leading-tight">The AI Partner That Delivers</h3>
            </div>
            <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {whyItems.map((item) => (
                <div key={item.title} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#C8F135]/10 flex-shrink-0">
                    <i className={`${item.icon} text-[#C8F135] text-base`} />
                  </div>
                  <div>
                    <p className="text-white text-sm font-bold mb-0.5">{item.title}</p>
                    <p className="text-zinc-400 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <Link to="/about" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#C8F135] text-black font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-[#b5e000] transition-colors flex-shrink-0">
              Learn More <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
